var $export = require('./_export');

$export($export.S + $export.F, 'Object', { isObject: require('./_is-object') });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.is-object.js
// module id = 285
// module chunks = 0 1